export const UPDATE_DATA_SOURCE_DATA = 'action.teammanagement.datasources.update';
export const UPDATE_PARTNERS_DATA = 'action.teammanagement.partners.update';
export const UPDATE_APPS_LIST = 'action.teammanagement.apps.list.update';
export const TEAMMANAGEMENT_PAGE_LOADED = 'action.teammanagement.page.loaded';
export const ORG_USERS_LOADED = 'action.teammanagement.org.users.loaded';
export const DELETE_MEMBER_CLICKED = 'action.teammanagement.delete.member.clicked';
export const DELETE_USER_INVITE_REVOKED = 'action.teammanagement.delete.user.invite.revoked';
export const DELETE_USER_DISABLED = 'action.teammanagement.delete.user.disabled';
export const SEND_INVITATION = 'action.teammanagement.send.invitation';
export const RESEND_INVITATION = 'action.teammanagement.resend.invitation';
export const MANAGE_PERMISSIONS_CALLED = 'action.teammanagement.manage.permissions.called';
export const MANAGE_PERMISSIONS = 'action.teammanagement.manage.permissions';
export const ADD_MESSAGE_TO_GROUP = 'action.teammanagement.add.message.to.group';
export const CLEAN_MESSAGES = 'action.teammanagement.clean.messages';
export const CREATE_NEW_MEMBER = 'action.teammanagement.create.new.member';
export const MANAGE_PERMISSIONS_FINISHED = 'action.teammanagement.manage.permissions.finished';
export const CLOSE_CONFIGURATION_REQUIRED_DIALOG = 'action.teammanagement.close.configuration.required.dialog';
export const WIZARD_ACTION_TYPE_CHANGED = 'action.teammanagement.wizard.actiontype.changed';
export const CLOSE_SHELF = 'action.teammanagement.close.shelf';
export const CLOSE_SHELF_CALLED = 'action.teammanagement.close.shelf.called';
export const HIDE_PAGE = 'action.teammanagement.hide.page';
export const HIDE_PAGE_CALLED = 'action.teammanagement.hide.page.called';
export const SELECTED_TAB_INDEX_CHANGED = 'action.teammanagement.selected.tab.index.changed';
export const STEP_VALIDATION_STATUS_CHANGED = 'action.teammanagement.step.validation.status.changed';
export const CLOSE_AGENCY_DIALOG = 'action.teammanagement.close.agency.dialog';
export const CLOSE_AGENCY_DIALOG_CALLED = 'action.teammanagement.close.agency.dialog.called';
export const UPDATE_USER_REGISTRATION_FORM = 'action.teammanagement.update.user.registration.form';
export const UPDATE_AGENCY_SELECTION_FORM = 'action.teammanagement.update.agency.selection.form';
export const UPDATE_ROLE_SELECTION_FORM = 'action.teammanagement.update.role.selection.form';
export const UPDATE_FEATURES_DICT = 'action.teammanagement.update.features.dict.form';
export const UPDATE_SECTIONS_DICT = 'action.teammanagement.update.sections.dict';
export const SAVE_MEMBER_ERROR = 'action.teammanagement.save.member.error';
export const SAVE_MEMBER_SUCCESS = 'action.teammanagement.save.member.success';
export const MODIFY_INVITATION_STATE = 'action.teammanagement.modify.invitation.state';
export const APP_SELECTION_CHANGE = 'action.teammanagement.appselection.select';
export const APP_SITE_SELECTION_CHANGE = 'action.teammanagement.appsiteselection.select';
export const DATA_SOURCE_SELECTION_CHANGE = 'action.teammanagement.dsselection.select';
export const DATA_SOURCE_SELECTION_CHANGE_ALL = 'action.teammanagement.dsselection.change.all';
export const DIMENSION_FILTER_SELECTION_CHANGE = 'action.teammanagement.dimension_filter.set';
export const METRIC_SELECTION_CHANGE = 'action.teammanagement.metricselection.select';
export const SCREENS_SELECTION_TOGGLE = 'action.teammanagement.screens.selection.toggle';
export const ADD_FUTURE_CHANGED = 'action.teammanagement.add.future.changed';
export const ACTIVE_MEMBER_TYPE_CHANGED = 'action.teammanagement.update.active_member_type';
export const UPDATE_SECTION_PERMISSIONS = 'action.teammanagement.update.section.permissions';
export const UPDATE_SDK_EVENTS = 'action.teammanagement.update.sdk.events';
export const SDK_EVENT_SELECTION_CHANGE = 'action.teammanagement.sdk.event.selection.change';
export const SHOW_CONFIRM_CHANGES_DIALOG = 'action.teammanagement.show.confirm.changes.dialog';
export const CONFIRM_CHANGES_ACCEPTED = 'action.teammanagement.confirm.changes.accepted';
export const CONFIRM_CHANGES_REJECTED = 'action.teammanagement.confirm.changes.rejected';
export const SET_INITIAL_PERMISSION_SNAPSHOT = 'action.teammanagement.set.initial.permission.snapshot';

export const teamManagementLoaded = () => ({
    type: TEAMMANAGEMENT_PAGE_LOADED,
});

export const getOrgUsers = orgUsers => ({
    type: ORG_USERS_LOADED,
    orgUsers,
});

export const deleteMemberClicked = member => ({
    type: DELETE_MEMBER_CLICKED,
    member,
});

export const userInviteRevoked = user => ({
    type: DELETE_USER_INVITE_REVOKED,
    user,
});

export const userDisabled = user => ({
    type: DELETE_USER_DISABLED,
    user,
});

export const sendInvitation = user => ({
    type: SEND_INVITATION,
    user,
});

export const resendInvitation = user => ({
    type: RESEND_INVITATION,
    user,
});

export const modifyInvitationState = (user, userState) => {
    return {
        type: MODIFY_INVITATION_STATE,
        user,
        userState,
    };
};

export const managePermissions = (user, partialState) => ({
    type: MANAGE_PERMISSIONS,
    user,
    partialState,
});

export const managePermissionsCalled = user => ({
    type: MANAGE_PERMISSIONS_CALLED,
    user,
});

export const cleanMessages = () => ({
    type: CLEAN_MESSAGES,
});

export const addMessageToGroup = (group, message, messageType) => ({
    type: ADD_MESSAGE_TO_GROUP,
    group,
    message,
    messageType,
});

export const createNewMember = () => ({
    type: CREATE_NEW_MEMBER,
});

export const closeShelf = () => ({
    type: CLOSE_SHELF,
});

export const closeShelfCalled = () => ({
    type: CLOSE_SHELF_CALLED,
});

export const hidePage = () => ({
    type: HIDE_PAGE,
});

export const hidePageCalled = () => ({
    type: HIDE_PAGE_CALLED,
});

export const selectedTabIndexChanged = selectedTabIndex => ({
    type: SELECTED_TAB_INDEX_CHANGED,
    selectedTabIndex,
});

export const stepValidationStatusChanged = stepValidationStatus => ({
    type: STEP_VALIDATION_STATUS_CHANGED,
    stepValidationStatus,
});

export const closeAgencyDialogCalled = () => ({
    type: CLOSE_AGENCY_DIALOG_CALLED,
});

export const closeAgencyDialog = () => ({
    type: CLOSE_AGENCY_DIALOG,
});

export const updateUserRegistrationForm = fields => ({
    type: UPDATE_USER_REGISTRATION_FORM,
    fields,
});

export const updateAgencySelectionForm = agency => ({
    type: UPDATE_AGENCY_SELECTION_FORM,
    agency,
});

export const updateRoleSelectionForm = role => ({
    type: UPDATE_ROLE_SELECTION_FORM,
    role,
});

export const managePermissionsFinished = recaptchaToken => ({
    type: MANAGE_PERMISSIONS_FINISHED,
    recaptchaToken,
});

export const saveMemberError = error => ({
    type: SAVE_MEMBER_ERROR,
    error,
});

export const saveMemberSuccess = () => ({
    type: SAVE_MEMBER_SUCCESS,
});

export const updateDataSourceData = data => ({
    type: UPDATE_DATA_SOURCE_DATA,
    data,
});

export const updatePartnersData = partners => ({
    type: UPDATE_PARTNERS_DATA,
    partners,
});

export const updateAppsList = appsList => ({
    type: UPDATE_APPS_LIST,
    appsList,
});

export const changeAppSelection = (appIDs, value) => ({
    type: APP_SELECTION_CHANGE,
    appIDs,
    value,
});

export const changeAppSiteSelection = (appSiteIDs, value) => ({
    type: APP_SITE_SELECTION_CHANGE,
    appSiteIDs,
    value,
});

export const changeDataSourceSelection = (name, value) => ({
    type: DATA_SOURCE_SELECTION_CHANGE,
    name,
    value,
});

export const changeAllDataSourceSelection = (allSources, value) => ({
    type: DATA_SOURCE_SELECTION_CHANGE_ALL,
    allSources,
    value,
});

export const setDimensionFilter = (name, values) => ({
    type: DIMENSION_FILTER_SELECTION_CHANGE,
    name,
    values,
});

export const changeMetricSelection = (metricID, value) => ({
    type: METRIC_SELECTION_CHANGE,
    metricID,
    value,
});

export const wizardActionTypeChanged = actionType => ({
    type: WIZARD_ACTION_TYPE_CHANGED,
    actionType,
});

export const closeConfigurationRequiredDialog = () => ({
    type: CLOSE_CONFIGURATION_REQUIRED_DIALOG,
});

export const addFutureChanged = (form, dimensionFilter, value, dataRestriction = false) => ({
    type: ADD_FUTURE_CHANGED,
    form,
    dimensionFilter,
    value,
    dataRestriction,
});

export const toggleScreens = (screenIds, value) => ({
    type: SCREENS_SELECTION_TOGGLE,
    screenIds,
    value,
});

export const updateFeaturesDict = featuresDict => ({
    type: UPDATE_FEATURES_DICT,
    featuresDict,
});

export const updateSectionsDict = sectionsDict => ({
    type: UPDATE_SECTIONS_DICT,
    sectionsDict,
});

export const activeMemberTypeChange = activeMemberType => ({
    type: ACTIVE_MEMBER_TYPE_CHANGED,
    activeMemberType,
});

export const updateSectionPermissions = (sectionNames, accessType) => ({
    type: UPDATE_SECTION_PERMISSIONS,
    sectionNames,
    accessType,
});

export const updateOrgSdkEvents = (events) => ({
    type: UPDATE_SDK_EVENTS,
    events,
});

export const changeSdkEventSelection = (eventNames) => ({
    type: SDK_EVENT_SELECTION_CHANGE,
    eventNames,
});

export const showConfirmChangesDialog = () => ({
    type: SHOW_CONFIRM_CHANGES_DIALOG,
});

export const confirmChangesAccepted = () => ({
    type: CONFIRM_CHANGES_ACCEPTED,
});

export const confirmChangesRejected = () => ({
    type: CONFIRM_CHANGES_REJECTED,
});

export const setInitialPermissionSnapshot = snapshot => ({
    type: SET_INITIAL_PERMISSION_SNAPSHOT,
    snapshot,
});
